var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoLofi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FFD3EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55322 51.9533C14.1594 45.3331 21.8236 41 30.4998 41C38.9253 41 46.3965 45.0863 51.0395 51.3853C45.6248 56.713 38.1962 60 29.9998 60C22.0988 60 14.9111 56.9456 9.55322 51.9533Z",
    fill: "#FE60A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4673 24.0225C37.9579 24.0824 36.4484 23.8428 35.1358 23.1836C36.3171 21.2063 37.1047 18.9893 36.6453 16.7124C36.4484 15.4541 35.6608 14.4355 34.4795 13.6566C33.4294 12.9975 32.1825 12.7578 31.0668 13.2971C30.5418 13.5966 30.148 14.1359 30.148 14.6752C30.0167 16.293 30.0167 17.9108 29.1636 19.3488C26.9978 18.3302 24.5695 17.5513 22.0756 17.9707C19.6473 18.3302 17.416 20.4274 18.1379 22.7642C18.1379 22.8241 18.2691 22.8241 18.2691 22.8841C18.5316 23.7229 19.5817 23.9027 20.4349 24.0225C22.01 23.7828 23.5195 24.2622 24.9633 24.8015C23.9789 26.4193 23.3882 28.2168 23.2569 30.0144C23.1913 31.033 23.4538 32.0516 24.1101 32.9504C24.2414 33.0702 24.307 33.1901 24.4383 33.3698C25.4227 34.4484 26.9322 35.3472 28.5073 34.8678C28.5729 34.8678 28.6385 34.8678 28.7042 34.8678C29.4261 34.5083 30.0167 33.9091 30.0167 33.1302C30.0167 31.5723 30.148 30.0144 30.9355 28.6363C31.6575 29.0557 32.445 29.3553 33.2326 29.595C33.4951 29.6549 33.692 29.6549 33.9545 29.7747C34.0857 29.8346 34.217 29.8346 34.3483 29.8346C34.4795 29.8945 34.5451 29.8945 34.6764 29.9545C36.3828 30.314 38.0891 30.3739 39.5986 29.535C41.0424 28.7561 42.1581 27.4379 42.0925 25.88C42.0269 24.6816 40.7143 23.8428 39.4673 24.0225Z",
    fill: "#FE60A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoLofi);
export default __webpack_public_path__ + "static/media/user-logo-lofi.99f1ef26022aa037a5bc29a6b2d62c34.svg";
export { ForwardRef as ReactComponent };